import BaseStore from './BaseStore'

export class ReportStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'reports'
  }
}

export default new ReportStore()


// WEBPACK FOOTER //
// ./src/stores/ReportStore.js